import { render, staticRenderFns } from "./rich_text_editor.vue?vue&type=template&id=516b31e0&scoped=true&"
import script from "./rich_text_editor.vue?vue&type=script&lang=js&"
export * from "./rich_text_editor.vue?vue&type=script&lang=js&"
import style0 from "./rich_text_editor.vue?vue&type=style&index=0&id=516b31e0&lang=postcss&scoped=true&"
import style1 from "./rich_text_editor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b31e0",
  null
  
)

export default component.exports